var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf"},_vm._l((_vm.pageCount),function(currentPage){return _c('pdf',{key:currentPage,attrs:{"src":_vm.src,"page":currentPage},on:{"loaded":_vm.loadPdfHandler}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }